module.exports = __webpack_public_path__ + "static/media/Dos.e186d21b.png";